import { unzlibSync, zlibSync } from 'fflate';

import type { Nullable } from '@src/shared/types/common';

function encodeUrl(text: string): string {
    return encodeURI(text)
        .replace(new RegExp(':', 'g'), '%3A')
        .replace(new RegExp('=', 'g'), '%3D')
        .replace(new RegExp('/', 'g'), '%2F');
}

function decodeUrl(text: string): string {
    return decodeURI(text)
        .replace(new RegExp('%3A', 'gi'), ':')
        .replace(new RegExp('%3D', 'gi'), '=')
        .replace(new RegExp('%2F', 'gi'), '/')
        .replace(new RegExp('\\+', 'g'), ' ');
}

function lineBreakToTag(text: string): string {
    const regexp = new RegExp('(\n|\r|\r\n)', 'g');
    return text ? text.replace(regexp, '<br>') : '';
}

function tagToLineBreak(text: string): string {
    const regexp = new RegExp('(<br\s*/?>)', 'g');
    return text ? text.replace(regexp, '\r\n') : '';
}

function stripHtmlTags(input: string | undefined) {
    if (input?.length) {
        input = input.replace('<br />', ', ');
        return input.replace(/<(?:.|\n)*?>/gm, '');
    }
    return input;
}

function removeTags(string: string): string {
    return string.replace(/<!--.*-->/g, '').replace(/¶/g, '');
}

function htmlEncode(string: string): string {
    return string
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/(?:^(?:&nbsp;)+)|(?:(?:&nbsp;)+$)/g, '');
}

function decode(encodedString: string): string {
    const parser = new DOMParser;
    const dom = parser.parseFromString(`<!doctype html><body>${encodedString}`, 'text/html');
    return dom.body.textContent;
}

function decodeString(string: string): string {
    const BR_PLACEHOLDER = '!"#%&_';
    const BR_PLACEHOLDER_RE = /!"#%&_/g;
    const HTML_ENTITIES_RE = /&(?:amp|lt|gt|quot|nbsp)/;

    string = string.replace(/<.?br.?\/>/g, BR_PLACEHOLDER);
    string = decode(string);

    while (HTML_ENTITIES_RE.test(string)) {
        string = decode(string);
    }

    return removeTags(string.replace(BR_PLACEHOLDER_RE, '<br/>'));
}

function getString(input: number) {
    return input < 10 ? `0${input}` : input.toString();
}

function removeHtml(str: string): string {
    return str.replace(/<[^>]*>?/gm, '');
}

/**
 * функция дописывает 0 слева от числа
 * */
function leftPad(number: number, targetLength: number): string {
    const isNegativeNumber = number < 0;
    let output = number.toString();
    if (isNegativeNumber) {
        output = output.replace('-', '');
    }

    while (output.length < targetLength) {
        output = `0${output}`;
    }

    return isNegativeNumber ? `-${output}` : output;
}

function formatNumber(number: number, length: number) {
    return number.toString().padStart(length, '0');
}

function padZero(str: string, length = 2) {
    const zeros = new Array(length).join('0');
    return (zeros + str).slice(-length);
}

function setTargetBlankForLinks({ sender }: kendo.ui.EditorEvent) {
    sender.body
        .querySelectorAll<HTMLAnchorElement>('a:not([target])')
        .forEach((anchor) => anchor.target = '_blank');
}

function compressToBase64(str: string): string {
    const chunkSize = 8192;
    const encoded = new TextEncoder().encode(str);
    const bytes = zlibSync(encoded);
    const parts: string[] = [];

    for (let i = 0; i < bytes.length; i += chunkSize) {
        parts.push(String.fromCharCode(...bytes.subarray(i, i + chunkSize)));
    }
    return btoa(parts.join(''));
}

function decompressFromBase64(str: string): string {
    const bytes = Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
    const decompressed = unzlibSync(bytes);
    return new TextDecoder().decode(decompressed);
}

function convertToMinutes(inputValue: string) {
    let result: Nullable<number> = null;
    if (inputValue) {
        const [hours, minutes] = inputValue.split(':').map(Number);
        result = hours * 60 + minutes;
    }
    return result;
}

window.getString = getString;
window.formatNumber = formatNumber;
window.leftPad = leftPad;
window.removeHtml = removeHtml;
window.decode = decode;
window.decompressFromBase64 = decompressFromBase64;
window.compressToBase64 = compressToBase64;
window.decodeUrl = decodeUrl;
window.encodeUrl = encodeUrl;
window.htmlEncode = htmlEncode;
window.convertToMinutes = convertToMinutes;
window.padZero = padZero;
window.decodeString = decodeString;
window.removeTags = removeTags;
window.lineBreakToTag = lineBreakToTag;
window.setTargetBlankForLinks = setTargetBlankForLinks;
window.stripHtmlTags = stripHtmlTags;
window.tagToLineBreak = tagToLineBreak;
